import { render, staticRenderFns } from "./FeedbackButtons.vue?vue&type=template&id=0152823a"
import script from "./FeedbackButtons.vue?vue&type=script&lang=js"
export * from "./FeedbackButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports